// dynamicStacks.js
import React, { useState, useEffect } from "react";
import Map from "./stacksMap";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";

function DynamicStacks() {
  const [targetObjects, setTargetObjects] = useState([]);
  const [FileName, setFileName] = useState(false);
  const { id } = useParams();

  // const location = useLocation();
  // const searchParams = new URLSearchParams(location.search);
  // const container = searchParams.get("container_no");

  useEffect(() => {
    // Fetch data from the API
    fetchData();
    //  alert(id)
  }, []);
  const fetchData = async () => {
    // alert(container);

    const location = id.replace("-", "/");
    // alert(location);
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch(
      "https://ctas.live/backend/api/get/yard/interfaces/data?location_name=" +
        location,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        setTargetObjects(result.containers);
        setFileName("3d/" + result.stack_name + ".glb");
        // setFileName('s3.glb');
        // alert(result.stack_name)
      })
      .catch((error) => console.error("responseError ::" + error));
  };

  return (
    <div>
      <pre>{/* {JSON.stringify(targetObjects)} */}</pre>
      {/* <Map targetObjects={targetObjects} fileName="3d/stack3-1.glb" /> */}
      {FileName ? (
        <Map targetObjects={targetObjects} fileName={FileName} />
      ) : null}
      {/* <Map targetObjects={targetObjects} fileName="C2.glb" /> */}
    </div>
  );
}

export default DynamicStacks;
